// Lib
import React from 'react';
import EmojiPopupContent from '../../../components/emoji/popup/EmojiPopupContent';
import useReactionsPopupHooks from './useReactionsPopupHooks';
import { ReactionsPopupContentProps } from './reactionsPopupTypes';

const ReactionsPopupContent: React.FC<ReactionsPopupContentProps> = (props) => {
    const { elementIds, closePopup } = props;

    const { selectedReactionIds, onSelectReaction } = useReactionsPopupHooks(elementIds);

    return (
        <EmojiPopupContent
            selectedEmojiIds={selectedReactionIds}
            onSelectEmoji={onSelectReaction}
            closePopup={closePopup}
        />
    );
};

export default ReactionsPopupContent;
